var map = {
	"./de.json": 88508,
	"./en.json": 97122,
	"@freshsolutions/fresh-vue-notes/src/locale/de.json": 88508,
	"@freshsolutions/fresh-vue-notes/src/locale/en.json": 97122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39659;